/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerFindOneQueryResponse, WorkflowTemplatesControllerFindOnePathParams, WorkflowTemplatesControllerFindOneQueryParams, WorkflowTemplatesControllerFindOne400, WorkflowTemplatesControllerFindOne401, WorkflowTemplatesControllerFindOne403, WorkflowTemplatesControllerFindOne404 } from "../../models/workflowsController/WorkflowTemplatesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowTemplatesControllerFindOne } from "../../clients/workflowsService/workflowTemplatesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowTemplatesControllerFindOneQueryKey = (id: WorkflowTemplatesControllerFindOnePathParams["id"], params: WorkflowTemplatesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/workflow-templates/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type WorkflowTemplatesControllerFindOneQueryKey = ReturnType<typeof workflowTemplatesControllerFindOneQueryKey>;
export function workflowTemplatesControllerFindOneQueryOptions(id: WorkflowTemplatesControllerFindOnePathParams["id"], params?: WorkflowTemplatesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowTemplatesControllerFindOneQueryKey(id, params);
  return queryOptions<WorkflowTemplatesControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindOne400 | WorkflowTemplatesControllerFindOne401 | WorkflowTemplatesControllerFindOne403 | WorkflowTemplatesControllerFindOne404>, WorkflowTemplatesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowTemplatesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a workflow template by id
 * {@link /api/v1/workflow-templates/:id}
 */
export function useWorkflowTemplatesControllerFindOne<TData = WorkflowTemplatesControllerFindOneQueryResponse, TQueryData = WorkflowTemplatesControllerFindOneQueryResponse, TQueryKey extends QueryKey = WorkflowTemplatesControllerFindOneQueryKey>(id: WorkflowTemplatesControllerFindOnePathParams["id"], params?: WorkflowTemplatesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowTemplatesControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindOne400 | WorkflowTemplatesControllerFindOne401 | WorkflowTemplatesControllerFindOne403 | WorkflowTemplatesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowTemplatesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...workflowTemplatesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowTemplatesControllerFindOne400 | WorkflowTemplatesControllerFindOne401 | WorkflowTemplatesControllerFindOne403 | WorkflowTemplatesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}